import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { Card, CardBody, CustomInput, Row, Col, Button } from "reactstrap";
import {
  useMenuTypeState,
  useMenuTypeDispatch,
} from "../../context/MenuTypeContext";
import { access_token } from "../../server/constants";
import MenuTypes from "./../menu-types";
import * as icons from 'react-bootstrap-icons'
const MenuTypeBar = ({ schoolList, authInfo }) => {
  const { selectedSchool, showMenuTypeBar, showDDSchool, showMenuTypeTabs } =
    useMenuTypeState();
  const dispatch = useMenuTypeDispatch();
  useEffect(() => {
    initSelectedSchool();
  }, [schoolList]);
  const initSelectedSchool = async () => {
    if ((schoolList || []).length == 1) {
      await dispatch({ type: "SET_SCHOOL", payload: { ...schoolList[0] } });
    }
  };

  return (
    showMenuTypeBar && (
      <Row>
        <Col xs={4} className="d-flex">
          {showDDSchool && (
            <>
              <select id="schooldd" className="form-control"
                disabled={(schoolList || []).length == 1}
                value={(selectedSchool || {}).schoolId || ""} onChange={({ target }) => {
                  const _selectedSchool = (schoolList || []).find((s) => {
                    return s.schoolId == target.value;
                  });
                  dispatch({ type: "SET_SCHOOL", payload: _selectedSchool });
                }}>
                <option key={-1} value={""}>
                  {"All Schools"}
                </option>
                {(schoolList || []).map((item, i) => {
                  return (
                    <option key={i} value={item.schoolId}>
                      {item.schoolName}
                    </option>
                  );
                })}
              </select>

              {((selectedSchool || {}).schoolId || 0) > 0 && (
                <button
                  type="button"
                  className="btn btn-outline-primary ml-2"
                  data-bs-toggle="tooltip"
                  title="Open School"
                  style={{ height: '36px' }}
                  onClick={(e) => {
                    if (((selectedSchool || {}).schoolId || 0) > 0) {
                      let protocal = window.location.protocol;
                      let mainDomain = window.location.host.replace(
                        window.location.host.split(".")[0],
                        ""
                      );
                      const btoaString = btoa(
                        `akey=${authInfo.access_token}&rkey=${authInfo.refresh_token}&loginModule=ROLE_CATERER`
                      );
                      const url = `${protocal}//${selectedSchool.subdomain}${mainDomain}?${btoaString}`;
                      window.open(url, "_blank");
                    }
                  }}
                >
                  <icons.BoxArrowUpRight />
                </button>
              )}
            </>
          )}
        </Col>
        <Col>

          {showMenuTypeTabs && <MenuTypes />}
        </Col>
      </Row>
    )
  );
};
export default MenuTypeBar;
